export default [
  {
    path: '/relDre/',
    name: 'relDre',
    title: 'relDre',
    component: () => import('../views/RelDreView.vue'),
    redirect: { name: 'relDre-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relDre-listar',
        component: () => import('../views/RelDreWelcomeView.vue'),
        meta: {
          title: 'Demonstrativo de resultado',
        },
      },
    ],
  },
];
